import React from "react";

import { Navigate } from "react-router-dom";

import {
    AboutPage,
    AddFamilyMemberPage,
    ChangeAddressPage,
    DocumentsPage,
    DocumentsSearchPage,
    PolicyholderDetailPage,
    PolicyholderPage,
    RelationDetailsPage,
    RequestsPage,
    RequestsSearchPage,
} from "@/components/features";
import { fakeI18n } from "@/i18n";
import { AppRoute, Identity, Permissions, RouteItem } from "@/shared/domain";
import { isABroker } from "@/shared/hooks";
import { Scope } from "@/shared/hooks/useAuth/types";

export const myAccountRoutes = (user: Identity): RouteItem[] => {
    return [
        {
            path: AppRoute.Documents,
            element: <DocumentsPage />,
            allowScopes: [Scope.SignPackages],
            breadcrumb: fakeI18n.t("Breadcrumbs.MyDocuments"),
        },
        {
            path: AppRoute.DocumentsSearch,
            element: <DocumentsSearchPage />,
            allowScopes: [Scope.SignPackages],
            breadcrumb: fakeI18n.t("Common.Search"),
        },
        { path: AppRoute.Requests, element: <RequestsPage />, breadcrumb: fakeI18n.t("Common.MyDemands") },
        {
            path: AppRoute.RequestsSearch,
            element: <RequestsSearchPage />,
            breadcrumb: fakeI18n.t("Common.Search"),
        },
        {
            path: AppRoute.Settings,
            element: <AboutPage />,
            allScopesAllowed: true,
            breadcrumb: fakeI18n.t("Breadcrumbs.Settings"),
        },
        {
            path: AppRoute.Relations,
            breadcrumb: fakeI18n.t("Breadcrumbs.Relation"),
            element: <Navigate to={AppRoute.Root} replace />,
        },
        {
            path: AppRoute.RelationDetail,
            element: <RelationDetailsPage />,
        },
        ...(!isABroker() && user.hasGlobalPermission(Permissions.AccessChangeAddress)
            ? [
                  {
                      path: AppRoute.ChangeAddress,
                      element: <ChangeAddressPage />,
                      breadcrumb: fakeI18n.t("Breadcrumbs.ChangeAddress"),
                      denyScopes: [Scope.Preview],
                  },
              ]
            : []),
        ...(user.hasGlobalPermission(Permissions.AccessAddFamilyMember)
            ? [
                  {
                      path: AppRoute.AddFamilyMember,
                      element: <AddFamilyMemberPage />,
                      breadcrumb: fakeI18n.t("Breadcrumbs.AddFamilyMember"),
                  },
              ]
            : []),
        ...(user.hasGlobalPermission(Permissions.ViewInformationDetail)
            ? [
                  {
                      path: AppRoute.PolicyholderDetail,
                      element: <PolicyholderDetailPage />,
                  },
              ]
            : []),
        ...(user.hasGlobalPermission(Permissions.ViewInformation)
            ? [
                  {
                      path: AppRoute.Policyholders,
                      element: <PolicyholderPage />,
                      breadcrumb: fakeI18n.t("Breadcrumbs.Policyholders"),
                  },
              ]
            : []),
    ];
};
